import { render, staticRenderFns } from "./FreezePackage.vue?vue&type=template&id=51e9873e&scoped=true"
import script from "./FreezePackage.vue?vue&type=script&lang=js"
export * from "./FreezePackage.vue?vue&type=script&lang=js"
import style0 from "./FreezePackage.vue?vue&type=style&index=0&id=51e9873e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e9873e",
  null
  
)

export default component.exports